import React, { useEffect } from "react";
import { useBlocker } from "react-router-dom";

interface PromptProps {
    hasUnsavedChanges: boolean;
}

export const UNSAVED_CHANGES_MESSAGE = "You have unsaved changes. Are you sure you want to leave?";

// Shows prompt on attempt to navigate away or refresh
const UnsavedChangesPrompt: React.FC<PromptProps> = ({ hasUnsavedChanges }) => {
    // Warn the user when attempting to close or refresh the page with unsaved changes
    useEffect(() => {
        const handleBeforeUnload = (e: any) => {
            if (hasUnsavedChanges) {
                e.preventDefault();
                e.returnValue = ""; // This triggers the browser's default prompt
            }
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [hasUnsavedChanges]);

    useBlocker(() => {
        if (hasUnsavedChanges) {
            return !window.confirm(UNSAVED_CHANGES_MESSAGE);
        }
        return false;
    });

    return null;
};

export default UnsavedChangesPrompt;
